module.exports = __webpack_public_path__ + "static/media/26.9069d7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/26.png
// module id = 808
// module chunks = 0